import { CALL_API } from "../middleware/api";
import {
    GET_ORGANIZATIONS_REQUEST,
    GET_ORGANIZATIONS_SUCCESS,
    GET_ORGANIZATIONS_FAILURE
} from "./actionTypes";
import OrganizationClient from '../lib/apiClients/roofSnapApiClient/organizationClient';
import QueryStringBuilder from "../lib/queryStringBuilder";

export const getOrganizations = (page = 1, search) => {
    const organizationClient = new OrganizationClient('v1');
    const request = organizationClient.getOrganizations;

    const queryStringBuilder = new QueryStringBuilder();
    queryStringBuilder.setQueryParameter('page', page);
    if (search) {
        queryStringBuilder.setQueryParameter('search', search);
    }
    const queryParams = queryStringBuilder.buildQueryString();

    return {
        [CALL_API]: {
            types: [
                GET_ORGANIZATIONS_REQUEST,
                GET_ORGANIZATIONS_SUCCESS,
                GET_ORGANIZATIONS_FAILURE
            ],
            request,
            params: {
                queryParams,
            },
        }
    };
};
